import { ChatService } from './chat.service';
import { Region } from '../shared/models';
import { AuthService, ConfigService, UserService } from '../shared/services';
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import * as moment from 'moment';

const dateFormat = 'MM/DD/YYYY hh:mm:ss A';

const enum ConnectionState {
    Connecting = 0,
    Connected = 1,
    Reconnecting = 2,
    Disconnected = 4
}

declare var $: JQueryStatic;

@Injectable()
export class SignalRService {

    private baseUrl: string;
    private token: string;
    private connectionState: ConnectionState;

    starting$: Observable<any>;
    connectionState$: Observable<ConnectionState>;
    error$: Observable<string>;

    private connectionStateSubject = new Subject<ConnectionState>();
    private startingSubject = new Subject<any>();
    private errorSubject = new Subject<any>();

    private hubProxy: SignalR.Hub.Proxy;
    private hubConnection: SignalR.Hub.Connection;

    constructor(private authService: AuthService,
        private userService: UserService,
        private configService: ConfigService,
        private chatService: ChatService) {
        if ($ === undefined || $.hubConnection === undefined) {
            throw new Error(`The variable '$' or the .hubConnection() function are not defined...please check the SignalR scripts have been loaded properly`);
        }

        this._subscribeToUser();

        this.baseUrl = this.configService.getContext('bi').url;

        this.connectionState$ = this.connectionStateSubject.asObservable();
        this.error$ = this.errorSubject.asObservable();
        this.starting$ = this.startingSubject.asObservable();

        this.hubConnection = $.hubConnection();
        this.hubConnection.url = `${this.baseUrl}signalr`;
        this.hubConnection.qs = `token=${this.token}`;
        this.hubProxy = this.hubConnection.createHubProxy('chat');
        this.hubConnection.transportConnectTimeout = 3000;

        this._subscribeToConnectionStates();
        this._subscribeToErrors();
        this._subscribeOnServerEvents();
    }

    public joinRegion(region: Region): any {
        this.hubProxy.invoke('JoinRegion', region.id)
            .done(() => {
                console.log('Susceffuly joine to region');
                return true;
            })
            .fail((error) => {
                console.log('Error joining to region ' + error);
                return error;
            });
    }

    public sendChatMessageToRegion(region: Region, text: string, timestamp: string): any {
        this.hubProxy.invoke('SendMessageToRegion', region.id, text, timestamp)
            .done(() => {
                console.log('Invocation of SendMessageToRegion succeeded');
                return true;
            })
            .fail((error) => {
                console.log('Invocation of SendMessageToRegion failed. Error: ' + error);
                return error;
            });
    }

    connect(): void {
        this.hubConnection.start()
            .done((data) => {
                console.log('Now connected ' + data.transport.name + ', connection ID= ' + data.id);
                this.startingSubject.next();
            })
            .fail((error: any) => {
                this.startingSubject.error(error);
                console.log('Could not connect ' + error);
            });
    }

    disconnect(): void {
        this.hubConnection.stop();
        this.startingSubject.next();
    }

    _subscribeToUser() {
        this.userService.user$.subscribe(() =>
            this.token = this.authService.accessToken
        );
    }

    _subscribeToConnectionStates() {
        this.hubConnection.stateChanged((state: any) => {
            this.connectionState = ConnectionState.Connecting;

            switch (state.newState) {
                case $.signalR.connectionState.connecting:
                    this.connectionState = ConnectionState.Connecting;
                    break;
                case $.signalR.connectionState.connected:
                    this.connectionState = ConnectionState.Connected;
                    break;
                case $.signalR.connectionState.reconnecting:
                    this.connectionState = ConnectionState.Reconnecting;
                    break;
                case $.signalR.connectionState.disconnected:
                    this.connectionState = ConnectionState.Disconnected;
                    break;
            }
            this.connectionStateSubject.next(this.connectionState);
        });
    }

    _subscribeToErrors() {
        this.hubConnection.error((error: any) => {
            this.errorSubject.next(error);
        });
    }

    _subscribeOnServerEvents(): void {
        this.hubProxy.on('sendMessage', (data) => {
            this.chatService.pushChatCommand({
                id: 'displayReceivedMessage',
                data: { message: data }
            });
        });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/chat/signalR.service.ts